export class Tools {
    public static camelize(str) {
        return str.replace(/_([a-z])/ig, function (g) {
            return g[1].toUpperCase();
        });
    }

    public static decamelize(str) {
        return str.replace(/([a-z][A-Z])/g, function (g) {
            return g[0] + '_' + g[1].toLowerCase();
        });
    }
}


// WEBPACK FOOTER //
// /app/src/model/Helpers/Tools.ts